import DataGrid, {Column} from "devextreme-react/data-grid";
import {ActionHistoryDetail} from "../types/ActionHistoryDetail";

export default function ActionHistoryGrid(props: { records: ActionHistoryDetail[] }) {

	return (
		<DataGrid
			className={'dx-card wide-card'}
			dataSource={props.records}
			allowColumnReordering={true}
			allowColumnResizing={true}
			showBorders={true}
			showColumnLines={true}
			rowAlternationEnabled={true}
			columnAutoWidth={false}
			keyExpr={'actionTransactionID'}
		>
			<Column
				dataField={'resolvedActions'}
				caption={'Resolved Actions'}
				dataType="string"
				cssClass={'multi-line'}
				width={'25%'}
			>
			</Column>
			<Column
				dataField={'newActions'}
				caption={'New Actions'}
				dataType="string"
				cssClass={'multi-line'}
				width={'25%'}
			/>
			<Column
				dataField={'createdOn'}
				caption={'Date Completed'}
				dataType="date"
				format="shortDate"
			/>
			<Column
				dataField={'description'}
				caption={'Description'}
				dataType="string"
			/>
			<Column
				dataField={'createdByName'}
				caption={'User'}
				dataType="string"
			/>
		</DataGrid>
	);
}
